const TaxType = {

    // FIELDS
    "name": "الاسم",
    "description": "الوصف",
    "status": "الحالة",
    "search": "البحث",

    // PAGE HEADER
    "tax_type": "نوع الضريبة",

    // ERROR
    "error_name": "الرجاء إدخال الاسم",
    "error_desc": "الرجاء إدخال الوصف",
    "error_status": "الرجاء اختيار الحالة",

    // TABLE HEADER
    "table_name": "الاسم",
    "table_description": "الوصف",
    "table_status": "الحالة",
}

export default TaxType;